<template>
  <section id="page-adventure" class="mdl-grid adv-content" >
    <div class="adv-image-container mdl-cell mdl-cell--12-col mdl-grid">        
        <div v-for="item in itemsByDate" class="mdl-cell--3-col mdl-cell--stretch mdl-card mdl-shadow--2dp ">
          <div v-if="item.cover" class="mdl-card__title" :style="'background-image: url('+item.cover+'); padding: 28.125% 0 28.125% 0; background-repeat: no-repeat; background-size: contain;  background-position: center;'">
          </div>
          <div v-else class="mdl-card__title" style="display: inline; background-color: #ccc; color: #999; font-size: 24px; font-weight: bolder; height: 0px; width: 100%; padding: 28.125% 0 28.125% 0; text-align: center;">
            NO COVER
          </div>
          <div class="mdl-card__title">
            <h2 class="mdl-card__title-text">{{item.name}}</h2>
          </div>
          <div class="mdl-card_subtitle">
            By <router-link to="/">{{item.owner.name}}</router-link>
          </div>
          <div class="mdl-card__supporting-text">
             Last Played: {{ item.lastPlayed | moment("Do MMM YYYY") }}
          </div>
          <div class="mdl-card__actions mdl-card--border">
            <router-link v-if="user" :to="('/play/'+item.key)" class="mdl-cell--12-col-phone mdl-button mdl-button--colored mdl-js-button mdl-js-ripple-effect">
              <i class="material-icons">play_arrow</i> {{getPlayText(item.key, items)}}
            </router-link>
            <router-link v-else to="login" class="mdl-button mdl-button--colored mdl-js-button mdl-js-ripple-effect">
              <i class="material-icons">play_arrow</i> Login to Play
            </router-link>
            <button v-if="user" class="mdl-cell--12-col-phone mdl-button mdl-js-button mdl-js-ripple-effect" @click="showDialog('shareAdventure', item.key)">
                  <i class="material-icons">share</i>
                  Share
              </button>
          </div>
        </div>
    </div>
     <dialog class="mdl-dialog shareAdventure">
      <div class="mdl-dialog__title">Share this adventure</div>
      <div class="mdl-dialog__content">
        <p>
          Share this URL with your friends:
          <input id="dialog_copy_text" class="mdl-textfield" style="width: 100%;" :value="'http://studio.adventify.com/#/play/'+selectedId" ></input>
            <button class="mdl-button mdl-button--raised" onclick="document.querySelector('#dialog_copy_text').select(); document.execCommand('copy'); document.querySelector('#dialog_copy_result').innerHTML = 'URL copied to clipboard!';" style="position: relative; top: 5px; ">SELECT AND COPY</button>
            <div style="position: relative; float: left;" id="dialog_copy_result">
          </div>
        </p>
      </div>
      <div class="mdl-dialog__actions mdl-dialog__actions">
        <button type="button" class="mdl-button close">CLOSE</button>
      </div>
    </dialog>
  </section>
</template>
<script>

import Vue from 'vue'
import TextTools from './TextTools.js';
  
Vue.use(require('vue-moment'));

var sectionFeed

export default{
  data: () => ({
      textTools: {},
      user: null,
      lastItem: null,
      items: {},
      isShowingAll: false,
      selectedId: null,
      savesInfoRef: {}
  }),
  created(){
      sectionFeed = this;
      this.textTools = TextTools;
      this.user = window.firebase.auth().currentUser;
      window.firebase.auth().onAuthStateChanged((user) => {
        sectionFeed.user = user;
        if(user){
          sectionFeed.loadSaves(user.uid);
        }
      });
  },
  methods: {
    getPlayText(advId, items){
      if(items[advId]){
        if(items[advId].finished){
          return 'Play Again';
        }
        return 'Continue';
      }
      return 'Play';
    },
    loadSaves(uid){
      this.savesInfoRef = window.firebase.database().ref('savesInfo/'+uid).orderByChild('lastPlayed');
      this.savesInfoRef.on('value',function(snapshot) {
          sectionFeed.items = snapshot.val();
      });
    },
    showDialog(dialogId, selectedId){
        this.selectedId = selectedId;
        var dialog = document.querySelector('dialog.'+dialogId);
        if (!dialog.showModal) {
          dialogPolyfill.registerDialog(dialog);
        }
        dialog.showModal();
        if(!dialog.listened){
          dialog.querySelector('.close').addEventListener('click', function() {
            dialog.close();
          });
        }
        dialog.listened = true;
    }
  },
  computed: {
    itemsByDate(){
      var currentItems = this.items;
      var result = Object.keys(currentItems).map(function(e) {
        var item = currentItems[e];
        item.key = e; 
        return item;
      });
      return result.sort(function(a,b){
        return b.lastPlayed - a.lastPlayed
      });
    }
  }
}

</script>




// WEBPACK FOOTER //
// SectionAdventureRecentFeed.vue?daee3946